exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlegend[data-v-9ff7db40] {\n  padding: 0.2em 0.2em;\n  border: 1px solid #d4d8da;\n  color: black;\n  font-size: 90%;\n  background-color: #e4e4e4;\n  margin-bottom: 20px;\n}\n.card[data-v-9ff7db40] {\n  margin-bottom: 1px;\n}\n.step-body[data-v-9ff7db40] {\n  width: 100%;\n  margin: auto;\n}\n.main-body[data-v-9ff7db40] {\n  margin-top: 20px;\n}\n.graph-body[data-v-9ff7db40] {\n  margin: 20px 200px 20px 200px;\n  background-color: white;\n}\n.nav-btn[data-v-9ff7db40] {\n  margin-top: 15px;\n  color: #ff9900;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9ff7db40","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/xpressathon/xpressathon.component.scss
// module id = 2089
// module chunks = 0